import useRequest from '@/websdk/utils/request';
import moment from 'moment';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/order/count?start_time=' + moment().startOf('day').unix() + '&end_time=' + moment().endOf('day').add(6, 'd').unix(),
    name: 'productionCountGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
